/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useQuery } from '@office-start/data-fetching';
import { useIdentity } from '@office-start/identity-service';
import { executeFeatureGatesDataFlow } from '../executeFeatureGatesDataFlow';
export function useFeatureGates() {
    var componentContext = useOfficeComponentContext().data;
    var identity = useIdentity().data;
    var query = ['FeatureGates'];
    return useQuery(query, function () { return executeFeatureGatesDataFlow(identity, componentContext); }, {
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: componentContext && identity,
    });
}
//# sourceMappingURL=useFeatureGates.js.map